import React from 'react';

import FilmProfileContainer from '../components/Films/ProfileContainer';

const FilmProfile = () => <FilmProfileContainer />;

export default FilmProfile;
